import { openSideModal } from '../../slices/sideModalSlice';
import { SideModalTabs } from '../../components/SideModal';

export const openDeliveryPicker = () => dispatch => {
  dispatch(openSideModal(SideModalTabs.STORE_SELECTOR));
};
